import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.MENTOR_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.MENTOR_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    "Missing MENTOR_PUBLIC_SUPABASE_URL or MENTOR_PUBLIC_SUPABASE_ANON_KEY environment variables",
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
